import useApiQuery from 'shared/hooks/use-api-query';
import {NeighborhoodProps} from '../types';
import neighborhoodsKeys from '../util/neighborhoods-keys';

const useCityNeighborhoodsByCompanySelect = (companyId?: string) => {
  const {data = [], ...rest} = useApiQuery({
    url: `/neighborhoods/companies/${companyId}/city`,
    queryKey: neighborhoodsKeys.companies(companyId!),
    enabled: !!companyId,
  });

  return {
    ...rest,
    data: data?.map((neighborhood: NeighborhoodProps) => ({
      label: neighborhood.name,
      value: neighborhood.id,
    })),
  };
};

export default useCityNeighborhoodsByCompanySelect;
